import { msalInstance } from '..';
import { getClients, getPersons, getRings, getSections, getTags } from '../Util/server';
import { BaseLoaderResult, baseUnauthorizedResponse } from './BaseLoader';

export type RingsAndSectionsResult = BaseLoaderResult & {};

const RingsAndSectionsLoader = async (): Promise<RingsAndSectionsResult> => {
  const loggedIn = Boolean(msalInstance.getActiveAccount());
  if (!loggedIn) {
    return baseUnauthorizedResponse;
  }
  const [rings, sections, tags, clients, persons] = await Promise.all([
    getRings(),
    getSections(),
    getTags(),
    getClients(),
    getPersons(),
  ]);
  return { rings, sections, tags, clients, persons };
};

export default RingsAndSectionsLoader;
